<template>
  <div>
    <certificate-list-add-new
      :is-add-new-certificate-sidebar-active.sync="isAddNewCertificateSidebarActive"
      @refetch-data="refetchData"
    />

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label>
          </b-col>

          <!-- Search & Add -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search job number..."
              />
              <b-button
                variant="primary"
                @click="isAddNewCertificateSidebarActive = true"
              >
                <span class="text-nowrap">Add New Certificate</span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table
        ref="refCertificatesListTable"
        class="position-relative"
        :items="fetchCertificates"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
        :busy.sync="isTableBusy"
      >
        <template #table-busy>
          <div class="text-center text-muted my-2">
            <b-spinner
class="align-middle mr-1"
small
/>
            <strong>Loading...</strong>
          </div>
        </template>

        <!-- Column: Issued At -->
        <template #cell(created_at)="data">
          <span class="text-nowrap">{{ dateFormat(data.item.created_at) }}</span>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-button
            variant="success"
            size="sm"
            :disabled="!data.item.document"
            @click="downloadAttachment(data.item.document)"
          >
            Download
          </b-button>
          &nbsp;
          <b-button
            variant="info"
            size="sm"
            :disabled="!data.item.certificate_id"
            @click="downloadCertificate(data.item.certificate_id)"
          >
            Download Certificate
          </b-button>
        </template>
      </b-table>

      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalCertificates"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
icon="ChevronLeftIcon"
size="18"
/>
              </template>
              <template #next-text>
                <feather-icon
icon="ChevronRightIcon"
size="18"
/>
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BPagination, BSpinner,
} from 'bootstrap-vue'
import axios from 'axios'
import vSelect from 'vue-select'
import moment from 'moment'
import { getToken } from '@/auth/utils'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import useCertificatesList from './useCertificatesList'
import CertificateListAddNew from './Add.vue'

export default {
  components: {
    CertificateListAddNew,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BPagination,
    BSpinner,
    vSelect,
  },
  data() {
    return {
      isAddNewCertificateSidebarActive: false,
      isTableBusy: false,
    }
  },
  setup() {
    const {
      fetchCertificates,
      tableColumns,
      perPage,
      perPageOptions,
      currentPage,
      totalCertificates,
      dataMeta,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refCertificatesListTable,
      refetchData,
    } = useCertificatesList()

    return {
      fetchCertificates,
      tableColumns,
      perPage,
      perPageOptions,
      currentPage,
      totalCertificates,
      dataMeta,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refCertificatesListTable,
      refetchData,
    }
  },
  methods: {
    dateFormat(value) {
      if (!value) return '-'
      return moment(String(value)).format('MM/DD/YYYY hh:mm')
    },
    downloadCertificate(certId) {
      const url = `https://access.protegocloud.com/notary/certificate/${certId}`
      window.open(url)
    },
    downloadAttachment(fileName) {
      const userToken = getToken()
      const headers = {
        'Content-Type': 'multipart/form-dataitem',
        'X-Token-Access': `Bearer ${userToken}`,
      }
      const url = 'https://api.geolims.com/asset_service/saved-assets/'
      const folderName = 'certificates/'
      const FileName = fileName.replace(url, '')
      const ObjectName = `${folderName}${FileName}`
      const bodyFormData = new FormData()
      bodyFormData.append('ObjectName', ObjectName)
      bodyFormData.append('FileName', FileName)
      axios
        .post('https://api.geolims.com/asset_service/get_asset', bodyFormData, { headers })
        .then(response => {
          if (response.data.Status === 1) {
            window.open(response.data.Payload, '_blank')
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Something went wrong',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Something went wrong',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
